import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TCCPHttpService } from '../../services/tccp-http.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { TCCPLoggerService } from '../../services/tccp-logger.service';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../../loader/loader.service';
import { HeadUnitPayload } from '../../models/headunit-payload';
import { Utilities } from '../../utilities';

@Injectable({
  providedIn: 'root'
})
export class PhoneManufacturerService {

  constructor(
    private readonly httpService: TCCPHttpService, private readonly http: HttpClient, private readonly logger: TCCPLoggerService,
    private readonly loaderService: LoaderService) { }
  public selectedPhoneData = [];
  public selectedHUPhoneConfigData: any = null;
  public appBase = TCCPConstantValues[environment.applicationName];
  public bluetoothCompatibilityURL = Utilities.getBluetoothExternalPath();

  getHUConfigList(requestData): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getManufaturerList,
      'Started getting Manufacturer', '');
    const manufaturerListURL = this.bluetoothCompatibilityURL + '/headunits';
    const headersObj = new HttpHeaders({
      nameCode: 'CCP', 'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    });

    return this.http.post(manufaturerListURL, requestData, { headers: headersObj }).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        return error;
      }
    )
    );
  }

  getBtVehicleList(): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getBtVehicleList,
      'Started getting model list', '');
    const btVehicleListURL = this.bluetoothCompatibilityURL + '/modelcodes';
    const headersObj = new HttpHeaders({
      nameCode: 'CCP', 'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    });

    return this.http.get(btVehicleListURL, { headers: headersObj }).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        return error;
      }
    )
    );
  }

  getManufaturerList(huConfigList: number[]): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BLUETOOTH_COMPATABILTITY_MODLE, this.appBase.methods.getManufaturerList,
      'Started getting Manufacturer', '');
    const manufaturerListURL = this.bluetoothCompatibilityURL + '/phonemodels';
    const headersObj = new HttpHeaders({
      nameCode: 'CCP', 'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    });
    return this.http.post(manufaturerListURL, { headUnitConfigIds: huConfigList }, { headers: headersObj }).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        return error;
      }
    )
    );
  }

  getHUPayload(modelName, year) {
    let requestData: HeadUnitPayload;
    requestData = {
      headUnitConfigArray: [],
      modelName: modelName,
      mpc: '',
      mpcOption: false,
      year: year
    };
    return requestData;
  }

  getBtHUPayload(modelName, year) {
    let requestData: HeadUnitPayload;
    requestData = {
      modelName: modelName,
      year: year
    };
    return requestData;
  }

  getBtHUPayloadWithModelCode(modelCode, modelName, mpc, year) {
    let requestData: HeadUnitPayload;
    requestData = {
      modelCode: modelCode,
      modelName: modelName,
      mpc: mpc,
      year: year
    };
    return requestData;
  }

}
